<template>
  <div  style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%;">
      <el-header class="padding" height="6%">
        <el-form label-width="10px">
          <el-row>
            <el-form-item>
              <el-select v-model="thing" @change="changeThing()" filterable clearable placeholder="物件番号" style="width:200px ;">
                <el-option v-for="item in things" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="month" format="YYYY 年 M 月" :clearable="false" value-format="YYYY-M-1"
                              type="month"
                              @change="changeMonth(month)" placeholder="请选择月份"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 80px" :loading="searchLoading" @click="getMonthProcessReality">搜索
              </el-button>
            </el-form-item>
            <el-button type="warning" style="margin-left: auto" :loading="dataJGRecoveryLoading" @click="jgPlanDataRecovery">计划数据修复</el-button>
          </el-row>
        </el-form>
      </el-header>
      <el-main class="padding" >
        <!--        <el-row>-->
        <!--          <el-button type="primary" plain style="width: 80px" :loading="exportLoading" @click="exportMonthProcessReality">导出</el-button>-->
        <!--        </el-row>-->
        <el-table :header-cell-style="headerCellStyle" :cell-style="{ textAlign: 'right', width: '100%',}" :data="tableData.slice((pageNum - 1) * pageSize, pageNum * pageSize)" border  style="width: 100%;height:92%;">
          <el-table-column prop="wujian_id" label="物件" :min-width="200" fixed/>
          <el-table-column v-for="item in countDayList" :key="item" :prop="item"
                           :label="(month.slice(5,7).includes('-')? '0' + month.slice(5,6):month.slice(5,7)) + '/' + item">
            <el-table-column :label="$t('makeSchedule.processProduceAchievement.plan')" :min-width="90">
              <template v-slot="scope">
                <div v-for="day in scope.row.busObjectList" :key="day">
                  <div :style="planCellStyle(day.planWeight)" v-if="day.date == item">{{ day.planWeight===undefined?'&nbsp;':day.planWeight.toLocaleString() }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :prop="item" :label="$t('makeSchedule.processProduceAchievement.achievements')" :min-width="90">
              <template v-slot="scope">
                <div v-for="day in scope.row.busObjectList" :key="day">
                  <div :style="actualCellStyle(day.realityWeight)" v-if="day.date == item">{{ day.realityWeight===undefined?'&nbsp;':day.realityWeight.toLocaleString() }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "ProcessActualProduction",
  data(){
    return{
      dataJGRecoveryLoading:false,
      formData: {
        day: this.getDateFormat(),
      },
      thing:'',
      things:[],
      month : this.getDateFormat(),
      searchLoading:false,
      exportLoading:false,
      countDayList:[],
      tableData:[],
      total: 0,
      pageNum: 1,
      pageSize: 15,
    }
  },methods:{
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
// 获取一个月有多少天，month是开始日期，获取这个日期的月份的天数
    getCountDays(month) {
      const d = new Date(month)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
    changeThing() {
      this.getMonthProcessReality();
    },
    changeMonth(month) {
      this.countDayList = [];
      this.getCountDays(month);
      this.getMonthProcessReality();
    },
    planCellStyle(data) {
      let cellStyle = 'background-color:#FFFF0080;text-align: right;'

      if (data < 0){
        cellStyle = 'background-color:lightcoral;color:white;text-align: right;'
      }
      if (data === undefined){
        cellStyle = 'background-color:white;text-align: right;'
      }
      return cellStyle
    },
    actualCellStyle(data) {
      let cellStyle = 'background-color:#4b8de4;color:white;text-align: right;'

      if (data < 0){
        cellStyle = 'background-color:lightcoral;color:white;text-align: right;'
      }
      if (data === undefined){
        cellStyle = 'background-color:white;text-align: right;'
      }

      return cellStyle
    },
    headerCellStyle({column}) {
      let headerCellStyle;

      if (column.label == "计划"){
        headerCellStyle = {color: 'orange'};
      }
      if (column.label == "实绩") {
        headerCellStyle = {color: 'blue'}
      }
      return headerCellStyle;
    },
    //加工数据修复
    async jgPlanDataRecovery() {
      this.dataJGRecoveryLoading = true;
      this.formData.day = this.month
      await this.$axios.post('mfg/processProduceAchievement/jgPlanDataRecovery',this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.dataJGRecoveryLoading = false;
          return this.$message.error(res.message);
        }
        this.dataJGRecoveryLoading = false;
        return this.$message.success('数据修复成功')
      })
    },
    getMonthProcessReality() {
      if (!this.month) {
        return this.$message.error("月份不能为空");
      }
      this.searchLoading = true;
      let params = {countDayList: this.countDayList, thing:this.thing, month:this.month};
      this.$axios.post('mfg/processProduceAchievement/getMonthProcessReality', params).then(response => {
        this.searchLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.tableData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })

    },
    exportMonthProcessReality() {
      if (!this.tableData) {
        return this.$message.error("导出的数据不能为空");
      }
      this.exportLoading = true;
      let params = {month: this.month, tableData: this.tableData};
      this.$axios.post('mfg/processProduceAchievement/exportMonthProcessReality', params).then(response => {
        this.exportLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        if (res.data.url) {
          const link = document.createElement('a');
          link.href = res.data.url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }

      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    currentCheckChange(pageNum) {
      this.pageNum = pageNum
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.things = res.data;
      this.productiveThings = res.data;
    },
  },created() {
    this.getCountDays(new Date());
    this.getWuJianInFo();
    this.getMonthProcessReality();
  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}
.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}

.el-table :deep(.cell){
  padding: 0px;
}
.el-table :deep(.el-table__cell) {
  padding: 1px;
}
</style>